import { useTranslation } from 'react-i18next';
import { TEMPLATE_ORDER, templateDef, type LayoutTemplate } from './layoutFormat';
import { LayoutPreviewGrid } from './LayoutPreviewGrid';

type TemplatePickerCardProps = {
  busy?: boolean;
  onPick: (template: LayoutTemplate) => void;
};

export function TemplatePickerCard({ busy = false, onPick }: TemplatePickerCardProps) {
  const { t } = useTranslation('layouts');
  return (
    <section
      className="flex w-full min-w-0 flex-col gap-4 self-stretch rounded-[14px] border px-6 py-[22px]"
      style={{
        background: 'var(--gs-panel)',
        borderColor: 'var(--gs-line)',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      <span className="flex flex-col gap-[3px]">
        <span className="text-[17px] font-extrabold tracking-[-0.015em]">{t('picker.title')}</span>
        <span className="text-[13.5px]" style={{ color: 'var(--gs-muted)' }}>
          {t('picker.subtitle')}
        </span>
      </span>
      <div
        className="grid w-full grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-4"
        style={{ width: '100%' }}
      >
        {TEMPLATE_ORDER.map((id) => {
          const def = templateDef(id);
          return (
            <button
              key={id}
              type="button"
              disabled={busy}
              onClick={() => onPick(id)}
              className="flex w-full min-w-0 flex-col gap-2.5 rounded-xl border-[1.5px] p-3 text-start disabled:opacity-50"
              style={{
                color: 'var(--gs-ink)',
                background: 'var(--gs-panel2)',
                borderColor: 'var(--gs-line)',
                fontFamily: 'inherit',
              }}
              onMouseEnter={(event) => {
                event.currentTarget.style.borderColor = 'var(--gs-accent)';
              }}
              onMouseLeave={(event) => {
                event.currentTarget.style.borderColor = 'var(--gs-line)';
              }}
            >
              <LayoutPreviewGrid def={def} />
              <span className="flex flex-col gap-0.5">
                <span className="text-[14.5px] font-bold">{t(`templates.${id}.name`)}</span>
                <span className="text-[12.5px]" style={{ color: 'var(--gs-muted)' }}>
                  {t(`templates.${id}.description`)}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
